import { render, staticRenderFns } from "./RestorePassword.vue?vue&type=template&id=4dfe5506&scoped=true&lang=pug"
import script from "./RestorePassword.vue?vue&type=script&lang=js"
export * from "./RestorePassword.vue?vue&type=script&lang=js"
import style0 from "./RestorePassword.vue?vue&type=style&index=0&id=4dfe5506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe5506",
  null
  
)

export default component.exports